import { toast } from 'sonner'

type ToastProps = {
  title: string
  description?: string
  duration?: number
  action?: {
    label: string
    onClick: () => void
  }
  dismissible?: boolean
}

export function useToast() {
  const success = ({ title, description, duration }: ToastProps) => {
    toast.success(title, { description, duration })
  }

  const info = ({
    title,
    description,
    duration,
    action,
    dismissible,
  }: ToastProps) => {
    toast.info(title, {
      dismissible,
      description,
      duration,
      actionButtonStyle: {
        backgroundColor: '#303F9F',
        color: '#FFF',
        border: 'none',
        borderRadius: '4px',
        padding: '8px 16px',
      },
      action,
    })
  }

  const error = ({ title, description, action, duration }: ToastProps) => {
    toast.error(title, {
      description,
      actionButtonStyle: {
        backgroundColor: '#f44336',
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        padding: '8px 16px',
      },
      action,
      duration,
    })
  }

  return {
    toast: {
      success,
      error,
      info,
    },
  }
}
